// Ce fichier définit les valeurs par defaut du state dans le GlobalContext
// ex: import INITIAL_STATE from '/contexts/INITIAL_STATE';

import I_STATE from './I_STATE';

const INITIAL_STATE: I_STATE = {
  from: ((new Date()).getFullYear() - 1).toString(),
  to: ((new Date()).getFullYear() + 2).toString(),
};
export default INITIAL_STATE;
